
import { Component, Vue } from 'vue-property-decorator';
import HeadingBlock from './card-blocks/HeadingBlock.vue';
import SelectionBlock from './card-blocks/SelectionBlock.vue';
import MainFooterBlock from './card-blocks/MainFooterBlock.vue';
import ResultsBlock from './card-blocks/ResultsBlock.vue';

@Component({ components: { HeadingBlock, SelectionBlock, MainFooterBlock,ResultsBlock } })
export default class MainCard extends Vue {
    calculateForYield = true

    onChangeCalculationType(value: any) {
        this.calculateForYield = value === 'YIELD';
    }
}
